__turbopack_context__.v({
  "form": "_S6E2W_form",
  "form__address-fields": "_S6E2W_form__address-fields",
  "form__address-fields-item": "_S6E2W_form__address-fields-item",
  "form__button": "_S6E2W_form__button",
  "search-form-container": "_S6E2W_search-form-container",
});
